// Order Deadline app:
// - Listen to when cart drawer has been built.
// 1. Insert an app placeholder/loading element within the cart drawer.
// 2. Trigger app's initFromViewCartPage method.
(function () {

  // Configuration variables
  // - adjust these for your store / cart drawer
  var configCartDrawerRootSelector = '#CartDrawerForm .drawer__inner .drawer__footer';                 // Selector for your cart drawer's root element
  var configCartDrawerPlacementTargetSelector = '#minicartsub';  // Selector for an existing element within the cart drawer. App places before/after this element based on settings.
  var configCartDrawerPlacementRelativity = 'before';                           // before or after. App will place relative to the placement target based on this setting
  var configCartDrawerHideEventName = 'cart:close';                // The event name emitted by your cart drawer for when it is hidden
  var configCartDrawerBuiltEventName = 'drawerOpen';                // The event name emitted by your cart drawer for when it has finished rebuilding (typically after the cart contents change)

  // Define cache variables
  // - When the cart drawer opens, we'll keep a cache of some existing values.
  // - When the cart drawer closes, we'll use put these values back.
  // - The app is usually only shown once per page, so if we don't do this
  //   closing the cart drawer and changing variant can cause some display issues
  //   since the app will reload itself based on the settings in place for the cart page.
  var cachedInstallConfig = null;
  var cachedTimerWrap = null;
  var cachedCssIsLoaded = null;
  var cartCssIsLoaded = false;

  // On Upside Cart Hidden event
  // - Return cached values to the app's settings
  document.addEventListener(configCartDrawerHideEventName, function(e){

    if (cachedInstallConfig) {
      window.orderDeadlineAppByEESL.installConfig = cachedInstallConfig;
      cachedInstallConfig = null;
    }

    if (cachedTimerWrap) {
      window.orderDeadlineAppByEESL.timerWrap = cachedTimerWrap;
      cachedTimerWrap = null;
    }

    if (cachedCssIsLoaded !== null) {
      window.orderDeadlineAppByEESL.cssIsLoaded = cachedCssIsLoaded;
    }

    // window.orderDeadlineAppByEESL.resetNew();

  });

  // On Upside Cart Built event
  document.addEventListener(configCartDrawerBuiltEventName, function(e){
  
    // Skip
    // - Order Deadline app has not loaded yet.
    if (!window.orderDeadlineAppByEESL || !window.orderDeadlineAppByEESL.hasLoaded) {
      console.log('#OD: Could not initialise within Upside cart drawer because Order Deadline app has not loaded yet.');
      return;
    }
  
    // Find cart drawer root
    var cartDrawerRoot = document.querySelector(configCartDrawerRootSelector);
  
    // Skip
    // - no cart drawer root found
    if (!cartDrawerRoot) {
      console.log('#OD: No cartDrawerRoot found.');
      return;
    }
  
    // Find placement target el
    var placementTarget = cartDrawerRoot.querySelector(configCartDrawerPlacementTargetSelector);
  
    // Skip
    // - no button container found
    if (!placementTarget) {
      console.log('#OD: No placementTarget found.');
      return;
    }
 
    // Cache app's existing installConfig
    // - when the cart drawer closes, we need to put back the original installConfig for the main product page
    if (!cachedInstallConfig && window.orderDeadlineAppByEESL.installConfig) {
      cachedInstallConfig = window.orderDeadlineAppByEESL.installConfig;
    }
    if (!cachedTimerWrap && window.orderDeadlineAppByEESL.timerWrap) {
      cachedTimerWrap = window.orderDeadlineAppByEESL.timerWrap;
    }
    if (!cartCssIsLoaded) {
      cachedCssIsLoaded = window.orderDeadlineAppByEESL.cssIsLoaded;
      window.orderDeadlineAppByEESL.cssIsLoaded = false;
      cartCssIsLoaded = true;
    }

    // Destroy existing app placement element
    var existingAppPlacementElement = cartDrawerRoot.querySelector('.trustblox-1-viewcart-wrap');
    if (existingAppPlacementElement && existingAppPlacementElement.parentNode) {
      existingAppPlacementElement.parentNode.removeChild(existingAppPlacementElement);
    }

    // Generate app placement element
    var appLoadingElement = document.createElement('div');
        appLoadingElement.classList.add('trustblox-1-viewcart-wrap');
  
    // Add appLoadingElement to DOM, prepended to placementTarget
    if (configCartDrawerPlacementRelativity == 'before') {
      console.log(cartDrawerRoot);
      console.log(placementTarget);
      cartDrawerRoot.insertBefore(appLoadingElement, placementTarget);
    } else if (configCartDrawerPlacementRelativity == 'after') {
      cartDrawerRoot.insertAfter(appLoadingElement, placementTarget);
    }
  
    // Trigger app's view cart page init method
    console.log('#initFromViewCartPage about to run');
    window.orderDeadlineAppByEESL.initFromViewCartPage();
  
  });

})();